function Tooltip({children}) {
    return <div className="dt-tooltip">
        <div className="dt-tooltip-text">{children}</div>
    </div>
}

export default Tooltip;